import { useCallback, useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { Check, RotateCcw, ZoomIn, ZoomOut } from "lucide-react";
import { Modal } from "./common";

const OUT = 512;

async function cropToBlob(src, area) {
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = src;
  });
  const canvas = document.createElement("canvas");
  canvas.width = OUT;
  canvas.height = OUT;
  canvas.getContext("2d").drawImage(img, area.x, area.y, area.width, area.height, 0, 0, OUT, OUT);
  return new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.9));
}

export function AvatarCropModal({ file, onCancel, onConfirm }) {
  const [src, setSrc] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [area, setArea] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setSrc(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const onComplete = useCallback((_, px) => setArea(px), []);
  const reset = () => { setCrop({ x: 0, y: 0 }); setZoom(1); };
  const confirm = async () => {
    if (!area) return;
    setBusy(true);
    try {
      const blob = await cropToBlob(src, area);
      await onConfirm(blob);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Profil fotoğrafını kırp" onClose={onCancel}>
      <div className="avatar-crop-area" data-testid="avatar-crop-area">
        {src && (
          <Cropper image={src} crop={crop} zoom={zoom} aspect={1} cropShape="round" showGrid={false}
            onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={onComplete} />
        )}
      </div>
      <p className="privacy-note" style={{ marginTop: 10 }}>Fotoğrafı sürükleyerek yüzünüzü daireye ortalayın, yakınlaştırmak için kaydırıcıyı kullanın.</p>
      <div className="avatar-crop-zoom">
        <ZoomOut size={15} />
        <input type="range" min={1} max={4} step={0.05} value={zoom} onChange={(e) => setZoom(Number(e.target.value))} data-testid="avatar-crop-zoom" />
        <ZoomIn size={15} />
        <button type="button" className="text-button" onClick={reset} data-testid="avatar-crop-reset"><RotateCcw size={13} /> Sıfırla</button>
      </div>
      <div className="modal-actions">
        <button type="button" className="outline-button" onClick={onCancel} disabled={busy} data-testid="avatar-crop-cancel">Vazgeç</button>
        <button type="button" className="primary-button" onClick={confirm} disabled={busy || !area} data-testid="avatar-crop-save">
          <Check size={15} /> {busy ? "Yükleniyor…" : "Kırp ve kaydet"}
        </button>
      </div>
    </Modal>
  );
}
